module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-metals-remnants.35973ca7.png";